export default __webpack_public_path__ + "static/bucky_standing-b1b73599b26954ba065d752e0396fcca.jpeg";